var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDependent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Dependent") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Level/Active/Dependent",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/social/dependent_24px",
    transform: "translate(6.000000, 6.000000) scale(-1, 1) translate(-6.000000, -6.000000) translate(0.000000, 1.500000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.10734767,5.33710366 C4.10854752,5.33710366 4.91888859,4.51856623 4.91888859,3.50723955 C4.91888859,2.49591286 4.10854752,1.67737544 3.10734767,1.67737544 C2.10614783,1.67737544 1.29580676,2.49591286 1.29580676,3.50723955 C1.29580676,4.51856623 2.10614783,5.33710366 3.10734767,5.33710366 Z M4.34954716,5.85992198 C3.78681414,5.75978445 3.37281695,5.70971568 3.1075556,5.70971568 C2.84229425,5.70971568 2.42815845,5.75978445 1.86514819,5.85992198 C0.800024536,6.08318082 0.00184895815,6.70296652 0.00184895815,7.74206792 L0.00184895815,8.6266163 C0.00184895815,9.03525523 -0.0485536368,8.99683188 0.376956237,8.99683188 L5.83895269,8.99683188 C6.26757621,8.99683188 6.21284639,9.05957522 6.21284639,8.6266163 L6.21284639,7.74206792 C6.21284639,6.70296652 5.34637096,6.03923062 4.34954716,5.85992198 Z",
    id: "Shape",
    fill: "#579800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.47426229,4.26968293 C9.64107076,4.26968293 10.5877267,3.31345186 10.5877267,2.13484146 C10.5877267,0.956231072 9.64107076,0 8.47426229,0 C7.30745381,0 6.36079788,0.956231072 6.36079788,2.13484146 C6.36079788,3.31345186 7.30745381,4.26968293 8.47426229,4.26968293 Z M8.45368799,4.83590531 C8.22472935,4.83590531 7.87782132,4.87181214 7.41296392,4.94362581 C6.92058263,5.03896069 6.20220438,5.16383496 5.83895269,5.37509531 C6.37612489,5.95995292 7.06528602,6.68472233 7.06528602,7.54310651 L7.06528602,8.39704309 C7.06528602,8.44596654 7.05427839,8.4926662 7.05207686,8.53936586 L11.5039466,8.53936586 C12.0719096,8.53936586 11.996703,8.67207272 11.996703,7.49929584 C11.996703,6.12276786 10.8495028,5.13959647 9.53306612,4.94362581 C9.04243935,4.87181214 8.68264663,4.83590531 8.45368799,4.83590531 Z",
    id: "Shape",
    fill: "#34436D"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDependent);
export default __webpack_public_path__ + "static/media/Dependent.3422f42f.svg";
export { ForwardRef as ReactComponent };